// TASK-1 ADAPTATION: LAB's SocialProof renders three hardcoded customer-logo
// images (`@/assets/logos/*`), none of which exist for Workshop and none of
// which we should invent. Adapted to a props-driven proof-point strip —
// capability claims, not customer names. Task 2 wires `points` from
// `@/content/proof` (`PROOF_POINTS`); it also stays the default here so any
// other caller gets sane content for free.
import { PROOF_POINTS, type ProofPoint } from "@/content/proof";
export type { ProofPoint };

export function SocialProof({ points = PROOF_POINTS }: { points?: ProofPoint[] }) {
  return (
    <section className="mx-auto max-w-6xl px-6 py-16">
      <p className="text-center text-xs font-bold uppercase tracking-[0.16em] text-muted-foreground">
        Proven on the GPU
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
        {points.map(({ label }) => (
          <span key={label} className="font-mono text-sm font-semibold tracking-tight text-foreground/70">
            {label}
          </span>
        ))}
      </div>
    </section>
  );
}
